module.exports = __webpack_public_path__ + "static/media/rm_06-07.81aaf635.png";